import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    getWidgetPerfInfo,
    PerformanceWidgetPerfs,
    WidgetInfoPerfParameter,
} from "@tecumseh/Services/PerformanceWidgetService";
import { CustomApiHandler } from "@tecumseh/Store/CustomHandlerCreator/CustomHandlerCreator";

type WidgetInfoHandlerType = CustomApiHandler<WidgetInfoPerfParameter, PerformanceWidgetPerfs>;

export const DispatchBeginWidgetPerfs: WidgetInfoHandlerType = props => {
    props.dispatch({
        type: "Custom/WidgetInfo/BeginLoadWidgetPerfs",
    });
};

export const SetFreq: WidgetInfoHandlerType = props => {
    props.dispatch({
        type: "Custom/WidgetInfo/SetSelectedFreq",
        selectedFreq: props.parameter.frequency,
    });
};

export const RequestWidgetPerfs: WidgetInfoHandlerType = async props => {
    props.apiResult = await getWidgetPerfInfo(props.parameter);
    if ((props.apiResult as any).error) {
        // TODO: Set Error in Reducer
        return false;
    }
};

export const WidgetPerfsCompleted: WidgetInfoHandlerType = props => {
    props.dispatch({
        type: "Custom/WidgetInfo/CompleteLoadWidgetPerfs",
        widgetPerfs: props.apiResult,
    });
};

export const widgetPerfsChain = [DispatchBeginWidgetPerfs, SetFreq, RequestWidgetPerfs, WidgetPerfsCompleted];

const loadPerformanceWidgetPerfs = createHandlerChainRunner(widgetPerfsChain, "LoadPerformanceWidgetPerfs");

export default loadPerformanceWidgetPerfs;
